// extracted by mini-css-extract-plugin
export default {"wrapper":"at-z","response":"bt-z","error":"ct-z","disabled":"dt-z","buttons":"et-z","feedbackQuestionSection":"ft-z","yesNoWrapper":"gt-z"};